import React from "react";
import BaseButton from "./BaseButton";
import carImage from "../assets/pictures/driver2.webp"

function BusinessCommercial() {
    return (
        <div className="driver-commercial-container">
            <img src={carImage} alt="" />
            <div className="text-block">
                <div className="subheading">VERSLUI</div>
                <h1 className="heading">JŪS ESATE MŪSŲ PRIORITETAS</h1>
                <p className="description">
                    Jūs būsite mūsų prioritetas, todėl ilgai laukti automobilio jums niekados nereikės. Mes pasirūpinsime jūsų kelione, o jūs
                    galėsite patogiai važiuoti ir pamiršti bent dalį dienos rūpesčių!
                </p>
                <div className="buttons">
                    <BaseButton
                        className={"baseButton--primary"}
                        text={"Registruotis"}
                        handleOnClick={() => window.location.href = 'https://1424.lt/verslui-registracija/'}
                    />
                    <a href="https://1424.lt/verslui/" className="link-secondary">PLAČIAU APIE VERSLUI TEIKIAMAS PASLAUGAS</a>
                </div>
            </div>
        </div>
    )
}

export default BusinessCommercial;